module.exports = __webpack_public_path__ + "static/img/logo.e254ef94.svg";